import { render, staticRenderFns } from "./ButtonBlok.vue?vue&type=template&id=3a932bbe&"
import script from "./ButtonBlok.vue?vue&type=script&lang=js&"
export * from "./ButtonBlok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports